/**
 * Account API
 * Handles API calls for account-level operations.
 */

import api from '@/features/api/axios';
import { logger } from '@/features/help/utils/logger';

/**
 * Permanently deletes the authenticated user's account.
 * This is an irreversible operation that removes all user data including:
 * - Database records (user profile, mappings, subscriptions, etc.)
 * - Stripe customer and subscriptions
 * - Custom domains from Vercel
 * - Logo files from cloud storage
 * - Firebase authentication
 *
 * @returns Promise that resolves on successful deletion
 * @throws Error if deletion fails
 */
export const deleteAccount = async (): Promise<void> => {
  logger.info('AccountAPI', 'Requesting account deletion');

  try {
    const response = await api.delete('/api/account');

    logger.success('AccountAPI', 'Account deleted successfully', {
      data: response.data,
    });

    return response.data;
  } catch (error) {
    logger.error('AccountAPI', 'Failed to delete account', { error });
    throw error;
  }
};

